import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { SubRegion } from "@app/shared/classes/subRegion";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { GenerateKpiDropDownItems, Kpi } from "@app/shared/classes/kpi";

export enum OthersFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpi_Translation_Id = "kpi_Translation_Id",
  kpiTime = "kpiTime",
  title = "title",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  fullName = "fullName",
  attachment = "attachment",

  rowNum = "rowNum",
  errorMessage = "errorMessage",
  kpiOthers_Id = "kpiOthers_Id"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",
  KPI_TIME = "ml_144009",
  TITLE = "ml_144010",
  ATTACHMENT = "ml_144011",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",

  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: OthersFieldName.driverName,
    sort: true,
    sortFieldName: OthersFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: OthersFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: OthersFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: OthersFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: OthersFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.KPI_NAME,
    name: OthersFieldName.kpi_Translation_Id,
    sort: true,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.KPI_TIME,
    name: OthersFieldName.kpiTime,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.TITLE,
    name: OthersFieldName.title,
    sort: true,
  },
  {
    text: FieldLabel.ATTACHMENT,
    name: OthersFieldName.attachment,
    sort: false,
  },
  {
    text: FieldLabel.CREATED_BY,
    name: OthersFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: OthersFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: OthersFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: OthersFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

const OthersSearchByList: SearchByItem[] = [
  { searchBy: OthersFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: OthersFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: OthersFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: OthersFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: OthersFieldName.kpiName, searchByLabel: FieldLabel.KPI_NAME, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: OthersFieldName.kpiTime, searchByLabel: FieldLabel.KPI_TIME, searchByType: smartSearchType.dateRangeSelct },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetOthersSearchByList = ([terminals, subRegions, kpis, userCountry]: [DropDownItem[], SubRegion[], Kpi[], string]) => {
  var result = OthersSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  result[4].searchDropDownValue = GenerateKpiDropDownItems(
    kpis.filter(kpi => kpi && kpi.kpiConfigurations && kpi.kpiConfigurations.filter(config => config && config.country === userCountry).length > 0));
  return result;
}
